import { ROUTE_PATH } from './consts';

export const createMerchantPageUrl = merchantId =>
  `${ROUTE_PATH.replace(':merchantId', merchantId)}`;
